export const LATEST = 'latest';
export const POPULAR = 'popular';
export const BOOKMARKS = 'bookmarks';
export const STRATEGIES = 'strategies';
export const SIGNALS = 'signals';
export const INSIGHTS = 'insights';
export const CALENDAR = 'economic-calendar';
